export default "/Citybus_Road.glb";